import { apiClient } from '../../../api/interceptor';
import { API_ROUTES } from './constants';

export const systemNotificationsList = (data) => {
  return apiClient({
    method: API_ROUTES.NOTIFICATIONS_LIST.METHOD,
    url: API_ROUTES.NOTIFICATIONS_LIST.URL,
    data,
  });
};

export const systemNotificationsUnreadCount = () => {
  return apiClient({
    method: API_ROUTES.NOTIFICATIONS_UNREAD_COUNT.METHOD,
    url: API_ROUTES.NOTIFICATIONS_UNREAD_COUNT.URL,
  });
};

export const markNotificationRead = ({ id }) => {
  return apiClient({
    method: API_ROUTES.NOTIFICATION_MARK_READ.METHOD,
    url: `${API_ROUTES.NOTIFICATION_MARK_READ.URL}/${id}/read`,
  });
};

export const markAllNotificationsRead = () => {
  return apiClient({
    method: API_ROUTES.NOTIFICATIONS_MARK_ALL_READ.METHOD,
    url: API_ROUTES.NOTIFICATIONS_MARK_ALL_READ.URL,
  });
};

export const deleteNotification = ({ id }) => {
  return apiClient({
    method: API_ROUTES.NOTIFICATION_DELETE.METHOD,
    url: `${API_ROUTES.NOTIFICATION_DELETE.URL}/${id}`,
  });
};

export const clearReadNotifications = () => {
  return apiClient({
    method: API_ROUTES.NOTIFICATIONS_CLEAR_READ.METHOD,
    url: API_ROUTES.NOTIFICATIONS_CLEAR_READ.URL,
  });
};

/**
 * Asks the API for a freshly signed Wasabi URL for a finished download job.
 * The link is never stored with the notification, so it has to be minted at
 * the moment the user clicks through.
 */
export const getDownloadJobUrl = ({ id }) => {
  return apiClient({
    method: API_ROUTES.DOWNLOAD_JOB_DOWNLOAD.METHOD,
    url: `${API_ROUTES.DOWNLOAD_JOB_DOWNLOAD.URL}/${id}/download`,
  });
};
